module.exports = __webpack_public_path__ + "img/visa.b084e89b.svg";